module.exports = __webpack_public_path__ + "img/69.3ac01492.gif";